import { api } from './client';

export interface SyncResult {
  ok: boolean;
  newCount: number;
  spamCount: number;
}

export interface SyncStatus {
  mailboxId: string;
  lastUid: number;
  lastSyncAt: number;
  isActive: boolean;
}

export async function syncMailbox(mailboxId: string): Promise<SyncResult> {
  return api.post<SyncResult>(`/mailboxes/${mailboxId}/sync`, {});
}

export async function getSyncStatus(mailboxId: string): Promise<SyncStatus> {
  return api.get<SyncStatus>(`/mailboxes/${mailboxId}/sync/status`);
}
